import type { SlumbrUser } from "../types/user";
import type { UserProfile } from "./user-api";

/**
 * Map a UserProfile API response into a SlumbrUser for the store.
 *
 * The backend returns the Cognito subject as `userId`, which is the
 * stable profile route and friend identifier used by the web app.
 */
export function mapProfileToUser(profile: UserProfile): SlumbrUser {
  return {
    id: profile.userId,
    username: profile.username ?? profile.email,
    displayName: profile.displayName,
    email: profile.email,
    avatar: profile.avatarUrl || "",
    banner: profile.coverImageUrl,
    bio: profile.bio,
    createdAt: profile.createdAt,
    preferences: {
      theme: "system",
      language: "en",
      notifications: {
        push: true,
        email: true,
        sound: true,
        mutedApps: [],
      },
    },
    presence: { online: true, lastSeen: new Date().toISOString() },
  };
}
